import { CurvedDivider } from "#components/CurvedDivider";
import LeadGen from "#components/LeadGen";
import { ROICalculator } from "#components/ROICalculator";
import Pricing from "#sections/Pricing";
import { Box } from "@chakra-ui/react";
import React from "react";

function PricingPage() {
  return (
    <>
      <Pricing />
      <CurvedDivider flip />
      <LeadGen />
      <CurvedDivider />
      <Box py={16} bg="white">
        <ROICalculator />
      </Box>
    </>
  );
}
export default PricingPage;
